import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import {
  getDocs,
  getDoc,
  collection,
  doc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import db from "../firestore";

  //Current Data
  //Hero Bg
  function EditImages() {
  const [oldHeroBg, setOldHeroBg] = useState("");
  const [heroBg, setHeroBg] = useState("");

  //Home Images
  const [oldHomeClothing1, setOldHomeClothing1] = useState("");
  const [oldHomeClothing2, setOldHomeClothing2] = useState("");
  const [homeClothing1, setHomeClothing1] = useState("");
  const [homeClothing2, setHomeClothing2] = useState("");

  //About Images
  const [oldAbout, setOldAbout] = useState("");
  const [about, setAbout] = useState("");

  //Database reference
  const heroBgRef = doc(db, "Images", "HeroBg");
  const homeRef = doc(db, "Pages", "Home");
  const aboutRef = doc(db, "Pages", "About");

  useEffect(() => {
    //Hero
    getDoc(heroBgRef).then((doc) => {
      setOldHeroBg(doc.data().url);
    });

    //Home
    getDoc(homeRef).then((doc) => {
      setOldHomeClothing1(doc.data().Clothing1Img);
      setOldHomeClothing2(doc.data().Clothing2Img);
    });

    //About
    getDoc(aboutRef).then((doc) => {
      setOldAbout(doc.data().ContentImg);
    });
  }, []);

  const updatingDoc = (dbRef, dataId, data) => {
    updateDoc(dbRef, {
      dataId: data,
    });
  };

  return (
    <div className="w-screen flex flex-col items-center">
      <Header />
      <div className="w-3/4 border rounded p-5 mt-5">
        <h1 className="font-bold text-2xl border-b pb-2">Images</h1>

        {/*----------Hero----------*/}
        <div className="w-full border p-2 h-full mt-10">
          <h2 className="text-xl">Hero Background</h2>
          <div className="flex flex-col items-center h-full">
            <div className="w-1/2 border p-5">
              <img src={oldHeroBg} alt="heroBg" />
            </div>
            <div className="w-1/2 flex flex-col justify-end">
              <input
                type="text"
                placeholder="Enter New Image URL"
                onChange={(e) => setHeroBg(e.target.value)}
                className="border border-black px-2 py-2"
              />
              <button
                className="bg-add-green text-white w-32 h-10 rounded mt-5"
                onClick={() => {
                  updatingDoc(heroBgRef, "url", heroBg);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {/*----------Home----------*/}
        <div className="w-full border p-2 h-full mt-10" id="Home">
          <h2 className="text-xl">Home Images</h2>
          <div className="flex flex-col items-center h-full mb-10">
            <div className="w-1/2 border p-5">
              <img src={oldHomeClothing1} alt="heroBg" />
            </div>
            <div className="w-1/2 flex flex-col justify-end">
              <input
                type="text"
                placeholder="Enter New Image URL"
                onChange={(e) => setHomeClothing1(e.target.value)}
                className="border border-black px-2 py-2"
              />
              <button
                className="bg-add-green text-white w-32 h-10 rounded mt-5"
                onClick={() => {
                  updatingDoc(homeRef, "Clothing1Img", homeClothing1);
                }}
              >
                Save
              </button>
            </div>
          </div>

          <div className="flex flex-col items-center h-full mb-10">
            <div className="w-1/2 border p-5">
              <img src={oldHomeClothing2} alt="heroBg" />
            </div>
            <div className="w-1/2 flex flex-col justify-end">
              <input
                type="text"
                placeholder="Enter New Image URL"
                onChange={(e) => setHomeClothing2(e.target.value)}
                className="border border-black px-2 py-2"
              />
              <button
                className="bg-add-green text-white w-32 h-10 rounded mt-5"
                onClick={() => {
                  updatingDoc(homeRef, "Clothing2Img", homeClothing2);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {/*----------Home----------*/}
        <div className="w-full border p-2 h-full mt-10" id="About">
          <h2 className="text-xl">About Images</h2>
          <div className="flex flex-col items-center h-full mb-10">
            <div className="w-1/2 border p-5">
              <img src={oldAbout} alt="heroBg" />
            </div>
            <div className="w-1/2 flex flex-col justify-end">
              <input
                type="text"
                placeholder="Enter New Image URL"
                onChange={(e) => setAbout(e.target.value)}
                className="border border-black px-2 py-2"
              />
              <button
                className="bg-add-green text-white w-32 h-10 rounded mt-5"
                onClick={() => {
                  updatingDoc(aboutRef, "ContentImg", about);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditImages;
